import { produce } from "immer";
import { ActionType, createReducer } from "typesafe-actions";
import { PropertiesFilter } from "@shared/interfaces";

import * as actions from "./actions";
import { PropertiesError, PropertySearchStateType } from "../interface/PropertiesState";

const defaultFilter: PropertiesFilter = {
  search: null,
  state_id: null,
  county_id: null,
};

const initialState: PropertySearchStateType = {
  propertyList: [],
  property: null,
  selectedPropertiesIds: [],
  total: 0,
  filter: { ...defaultFilter },
  propertyCheckForAssign: {
    error: false,
    message: "",
  },
  errors: {
    [PropertiesError.gePropertiesError]: null,
    [PropertiesError.gePropertyError]: null,
  },
};

const reducer = createReducer<PropertySearchStateType, ActionType<typeof actions>>(initialState)
  .handleAction(actions.getProperties.success, (state, action) =>
    produce(state, (nextState) => {
      const { items, total } = action.payload;
      nextState.propertyList = [...items];
      nextState.total = total;
    }),
  )
  .handleAction(actions.getProperty.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.property = action.payload;
    }),
  )
  .handleAction(actions.checkIfPropertyCouldBeAssignedToLead.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.propertyCheckForAssign.error = false;
      nextState.propertyCheckForAssign.message = "";
      nextState.propertyCheckForAssign.property = action.payload;
    }),
  )
  .handleAction(actions.checkIfPropertyCouldBeAssignedToLead.failure, (state, action) =>
    produce(state, (nextState) => {
      nextState.propertyCheckForAssign.error = true;
      nextState.propertyCheckForAssign.message = action.payload.message || "Something went wrong";
      nextState.propertyCheckForAssign.property = null;
    }),
  )
  .handleAction(actions.setFilter, (state, action) =>
    produce(state, (nextState) => {
      if (action.payload) {
        nextState.filter = {
          ...nextState.filter,
          ...action.payload,
        };
      } else {
        nextState.filter = { ...defaultFilter };
      }
    }),
  )
  .handleAction(actions.selectProperty, (state, action) =>
    produce(state, (nextState) => {
      nextState.selectedPropertiesIds = [...nextState.selectedPropertiesIds, action.payload];
    }),
  )
  .handleAction(actions.unselectProperty, (state, action) =>
    produce(state, (nextState) => {
      nextState.selectedPropertiesIds = nextState.selectedPropertiesIds.filter((id) => id !== action.payload);
    }),
  )
  .handleAction(actions.selectAllProperties, (state) =>
    produce(state, (nextState) => {
      nextState.selectedPropertiesIds = nextState.propertyList?.map((property) => property.dataflik_id) ?? [];
    }),
  )
  .handleAction(actions.unselectAllProperties, (state) =>
    produce(state, (nextState) => {
      nextState.selectedPropertiesIds = [];
    }),
  );
export { reducer as DataDeliveryReducer };
